module.exports = __webpack_public_path__ + "static/media/transfert_argent.df5421c4.png";